import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { NzButtonModule, NzButtonSize } from 'ng-zorro-antd/button';
import { TranslocoModule } from '@jsverse/transloco';
import { IconModule } from '@app/shared/directives/icon.directive';

export interface AppButtonConfig {
  label: string;
  type?: ButtonType;
  color?: ButtonColor;
  size?: NzButtonSize;
  styles?: Record<string, string>;
  prefixIcon?: string;
  suffixIcon?: string;
  action?: (_?: any) => void;
  /**
   * whether button is type submit
   */
  submit?: boolean;
  /**
   * whether button is display: block and width 100% (default true)
   */
  block?: boolean;
  isLoading$?: Observable<boolean>;
  /**
   * If true, will render as <a> tag,
   */
  link?: boolean;
  href?: string;
  target?: 'blank' | '_blank' | '_self' | '_top' | 'unfencedTop';
}

export type ButtonColor = 'primary' | 'secondary' | 'dark' | 'light' | 'danger';

export type ButtonType = 'primary' | 'secondary' | 'ghost' | 'text';

@Component({
  selector: 'app-button',
  imports: [CommonModule, NzButtonModule, TranslocoModule, IconModule],
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.less'],
})
export class ButtonComponent {
  @Input() public config: AppButtonConfig;
  // TODO: replace with static data for action
  @Input() public componentInstance?: any;
  @Output() btnClick = new EventEmitter<void>();

  public onClick() {
    this.btnClick.emit();
    this.config.action?.(this.componentInstance);
  }
}
